module.exports = __webpack_public_path__ + "static/media/upload.09e39214.svg";